import { WISHLISTS_SDK_EVENTS } from "./constants";

class WishlistsSdkEvents {
    public readonly WISHLIST_ITEM_CREATED =
        WISHLISTS_SDK_EVENTS.WISHLIST_ITEM_CREATED;

    public readonly WISHLIST_ITEM_DELETED =
        WISHLISTS_SDK_EVENTS.WISHLIST_ITEM_DELETED;

    public readonly WISHLIST_ITEM_ADDED_TO_CART =
        WISHLISTS_SDK_EVENTS.WISHLIST_ITEM_ADDED_TO_CART;
}

export default WishlistsSdkEvents;
